import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable record search query on /api/v1/record-search-query instead of /api/v3/search/products
 */
export const ENABLE_RECORD_SEARCH_QUERY_ON_SEPARATE_API_250319 =
  'ENABLE_RECORD_SEARCH_QUERY_ON_SEPARATE_API_250319' as SettingConst<
    'ENABLE_RECORD_SEARCH_QUERY_ON_SEPARATE_API_250319',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
